import { Component } from '@angular/core';
import { SizeWindowService } from './shared/services/size-window.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'EspaceNotaire-Front';

  outerWidth: number = 0;
  innerHeight: number = 0;

  favTitle: HTMLLinkElement | null = null;

  constructor(private sizeWindowService: SizeWindowService) {
    if (window !== undefined) {

      this.outerWidth = window.outerWidth;
      this.innerHeight = window.innerHeight;

      this.sizeWindowService.findSizeWindow(this.outerWidth, this.innerHeight);
  
      window.addEventListener('resize', (event: any) => {
        console.log(event)
        if ((this.outerWidth != window.outerWidth) || (this.innerHeight != window.innerHeight)) {
          this.outerWidth = window.outerWidth;
          this.innerHeight = window.innerHeight;
          // console.log(window.outerWidth, window.innerHeight)
          this.sizeWindowService.findSizeWindow(this.outerWidth, this.innerHeight);
        }
      });
    }
  }
}
